'use strict';

var MarketProductGroupTDChartMarketsFilterFactory = function MarketProductGroupTDChartMarketsFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupDateRangeFilterFactory', 'MarketProductGroupSeasonFilterFactory', 'MarketProductGroupClassGroupFilterFactory', 'MarketProductGroupDowFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function MarketProductGroupTDChartMarketsFilter() {
    DemandFilter.call(this, 'market-product-group', 'thematic-demand-chart-market-markets');
    this.registerFilters(injectedFilters);
  }
  MarketProductGroupTDChartMarketsFilter.constructor = MarketProductGroupTDChartMarketsFilter;
  MarketProductGroupTDChartMarketsFilter.prototype = Object.create(DemandFilter.prototype);
  return MarketProductGroupTDChartMarketsFilter;
};
MarketProductGroupTDChartMarketsFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketProductGroupTDChartMarketsFilterFactory;